module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbsExtended,
      "wide": true
    }
  }, [(_vm.showUnlimit) ? _c('MapNotification', [_vm._v("На карте отображены только основные адреса организаций"), _c('template', {
    slot: "small"
  }, [_vm._v("Отображение всех объектов может существенно повлиять на скорость работы сайта!")]), _c('ExtButton', {
    attrs: {
      "slot": "action",
      "size": "small",
      "factor": 1.2,
      "fill": false,
      "to": _vm.unlimitedRoute
    },
    slot: "action"
  }, [_vm._v(_vm._s(_vm.showAllText))])], 2) : _vm._e(), _c('MapPageLayout', {
    attrs: {
      "points": _vm.points,
      "filtered": _vm.filtered,
      "empty-text": _vm.emptyText,
      "update-events": _vm.updateEvents,
      "route-name": _vm.organizationRouteName
    }
  }, [_c('FlexFilter', _vm._b({
    attrs: {
      "slot": "filter"
    },
    slot: "filter"
  }, 'FlexFilter', _vm.filterProps, false))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d5b3219","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/map/component.vue
// module id = 690cb9ac4c323ebba3c4
// module chunks = 41